import React from "react";

import Body from "../component/Body.jsx";
import Carousel from "../component/Carousel.jsx";
import DrivenBySpirit from "../component/DrivenBySpirit.jsx";
import CelebratingCampaign from "../component/CelebratingCampaign.jsx";
import MakingHeadlines from "../component/MakingHeadlines.jsx";
import KeepingSpiritAlive from "../component/KeepingSpiritAlive.jsx";
import SoundofIndia from "../component/SoundofIndia.jsx";
import JindalVideo from "../component/JindalVideo.jsx";
import ThesteelofIndia from "../component/ThesteelofIndia.jsx";

const Home = () => (
  <div>
    <Carousel />
    <DrivenBySpirit />
    <JindalVideo />
    <ThesteelofIndia />
    <Body />
    <SoundofIndia />
    <CelebratingCampaign />
    <MakingHeadlines />
    <KeepingSpiritAlive />
  </div>
);

export default Home;
